import { withUser } from 'components/queries/GetUserQuery';
import Header from './Header';

export default withUser(Header, {
  fetchPolicy: 'cache-only'
});
